import { combineEpics } from 'redux-observable'

import { createInvokeEpic } from '../../../signalr/createInvokeEpic'
import { createStreamEpic } from '../../../signalr/createStreamEpic'

import {
  fetchTierDefinition,
  revertTierDefinition,
  saveTierDefinition
} from './definition'

export default combineEpics(
  createStreamEpic('tiers.fetch', fetchTierDefinition),
  createInvokeEpic('tiers.revertTier', revertTierDefinition),
  createInvokeEpic('tiers.saveTier', saveTierDefinition)
)
